import cookies from 'js-cookie';

const getHostEntity = () => {
  let hostUrl = `//gateway-uat1.dandythrust.com/graphql`;
  let imageUrl = '//image.dandythrust.com';
  let cdnUrl = 'hurricane-cn.dandythrust.com';
  let fileCdnUrl = 'https://storm-frontend-cdn.dandythrust.com';
  let propertyUrl = 'https://hurricane-www.dandythrust.com/';
  let authUrl = '//hurricane-www.dandythrust.com/';
  let facadeUrl = '//cms-facade-uat1.dandythrust.com';
  let agentUrl = window.location.origin + '/agent';

  let hostName = process.env.HOST_NAME;

  //TODO: 需要编写插件
  //@building-removing start
  let hostNameFromCookie = process.env.PUBLIC_URL && cookies.get(process.env.PUBLIC_URL.slice(11));
  if (process.env.HOST_NAME !== 'prod' && hostNameFromCookie) {
    hostName = hostNameFromCookie;
  }
  //@building-removing end

  switch (hostName) {
    case 'uat1':
    case 'uat2':
    case 'uat3':
      authUrl = `https://${hostName}-www.dandythrust.com/`;
      hostUrl = `https://gateway-${hostName}.dandythrust.com/graphql`;
      cdnUrl = `https://${hostName}-cn.dandythrust.com`;
      facadeUrl = `https://cms-facade-${hostName}.dandythrust.com`;
      propertyUrl = `https://${hostName}-www.dandythrust.com/`;
      break;
    case 'stage':
      hostUrl = `https://gateway-ap.dandythrust.com/graphql`;
      cdnUrl = 'https://hurricane-cn.dandythrust.com';
      facadeUrl = `//cms-facade.dandythrust.com`;
      propertyUrl = `https://hurricane-www.dandythrust.com/`;
      break;
    case 'prod':
      propertyUrl = 'https://www.student.com/';
      authUrl = '//www.student.com/';
      hostUrl = '//gateway-ap.student.com/graphql';
      imageUrl = '//image.student.com';
      cdnUrl = '//cn.student.com';
      facadeUrl = `//cms-facade.student.com`;
      agentUrl = 'https://dashboard.student.com/agent';
      fileCdnUrl = 'https://cdn.student.com';
      break;
    default:
      break;
  }

  return {
    imageUrl,
    hostUrl,
    propertyUrl,
    cdnUrl,
    facadeUrl,
    prefix: `pms_${hostName}_`,
    authImageUrl: propertyUrl,
    hostName,
    authUrl,
    agentUrl,
    fileCdnUrl,
  };
};

export const Hosts = getHostEntity();
